import format from 'date-fns/format';

export const formatDate = (
  time: string | number | Date,
  dateformat = 'dd.MM.yyyy',
): string => format(new Date(time), dateformat);
